import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const FutureCashCropCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/ui/cropNames')
  const detail = params.row.findDetail({ traitId, year })

  return <>{detail ? t(detail.input?.crop ?? detail.result) : ''}</>
}
